export const ADD_EXISTING_BRANCH_COLLECTION = "ADD_EXISTING_BRANCH_COLLECTION";
export const CREATE_NEW_BRANCH_COLLECTION = "CREATE_NEW_BRANCH_COLLECTION";
export const DELETE_BRANCH_COLLECTION = "DELETE_BRANCH_COLLECTION";